<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="FormLayout" scope="props">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div v-if="dataValid" >
          <div class="row">
            <detail-field v-if="!isNew" class="col-md-6" label="Number" field="number" :rec="props.rec" :isReadOnly="!isNew" vvalidate="ok" :validator="validator"/>
            <detail-field class="col-md-6" label="Contract/Student" field="contract_id" :optionListApiUrl="'/contracts/choice/'" :rec="props.rec" :isReadOnly="!isNew" vvalidate="required" :validator="validator"/>
            <detail-field v-if="(props.rec.scholarship_payment_type_id === 2) " class="col-md-6" label="Invoice/Credit Note" field="linked_invoice_id" :optionListApiUrl="'/invoices_credit_notes/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          </div>
          <div class="row">
            <detail-field class="col-md-6" label="Payment Type" field="scholarship_payment_type_id" :optionListApiUrl="'/scholarship_payment_types/choice/'" :rec="props.rec" :isReadOnly="!isNew" vvalidate="required" :validator="validator"/>
            <detail-field class="col-md-6" label="Period" field="period" :rec="props.rec" :isReadOnly="!isNew" vvalidate="ok" :validator="validator"/>
            <detail-field class="col-md-6" label="Amount" field="amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="required" :validator="validator"/>
            <detail-field class="col-md-6" label="Description" field="description" :rec="props.rec" :isReadOnly="isReadOnly || (isEdit && !isPlanned)" vvalidate="ok" :validator="validator"/>
          </div>
          <div class="row">
            <detail-field class="col-md-6" label="Planned Date" field="planned_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="required" :validator="validator"/>
            <detail-field v-if="!isNew" class="col-md-6" label="Payment Date" field="payment_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
          </div>
          <div class="row">
            <detail-field class="col-md-6" label="Comments" field="comments" type="textarea" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
            <detail-field v-if="(props.rec.scholarship_payment_type_id === 5)"class="col-md-6" label="University" field="university_id" :optionListApiUrl="'/universities/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
          </div>
          <div class="row" v-if="!isNew" >
            <detail-field class="col-md-6" label="Exported" field="exported_timestamp" field2="exported_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
          </div>
          <div class="row" v-if="!isNew" >
            <detail-field class="col-md-6" label="Created" field="creation_timestamp" field2="creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
          </div>
          <div class="row" v-if="!isNew" >
            <detail-field class="col-md-6" label="Last Edit" field="edit_timestamp" field2="edit_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
          </div>
        </div>
      </b-form>
    </template>
    <template slot="ExtraOptions" scope="props">
        <b-dropdown v-if="privUser && isNumbered" variant="default" size="sm">
          <template slot="button-content"> <i class="fa fa-cog"></i> </template>
          <b-dropdown-item v-if="isNumbered" @click="resetExport(props.rec)">Reset Export</b-dropdown-item>
        </b-dropdown>
    </template>
  </detail-layout>
</template>

<script>
// import api from '../../api'
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'scholarshippayment_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  computed: {
    isPlanned () { return this.tableCfg.subType(this) === 'planned' },
    isNumbered () { return this.tableCfg.subType(this) === 'numbered' }
  },
  methods: {
    resetExport (rec) {
      rec.exported_userid = null
      rec.exported_timestamp = null
      this.api.putUpdate(this.tableCfg.detailApiUrl + rec.id, rec,
      data => { this.$router.push({name: this.detailRouterUrl, params: {id: rec.id}}) },
      'resetting export', this.$refs.layout.$refs.alert)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?0fca22de